export const homepage = {
	homepage: {
		greeting: "Hi, I am",
		allProjects: "View All Projects",
		latestArticles: "Latest Articles",
		allArticles: "View All Articles",
		work: {
			title: "Work",
			company: "CyberAgent Inc.",
			position: "Software Engineer",
			duration: "2019 - Present",
		},
	},
} as const;
